import { getEnv, Instance, types } from "mobx-state-tree";

export const DownloadInspectionFilesModel = types
  .model({
    sectionName: types.string,
    inspectionName: types.string,
    archiveName: types.optional(types.string, ""),
    defaultArchiveName: types.optional(types.string, ""),
    archiveNameSetupModalIsVisible: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    showArchiveNameSetupModal() {
      self.archiveNameSetupModalIsVisible = true;
      self.archiveName = `${getEnv(self).translationService.translate("general.section")}_${
        self.sectionName
      }_${getEnv(self).translationService.translate("general.inspection")}_${self.inspectionName}`;
      self.defaultArchiveName = self.archiveName;
    },

    setArchiveName(archiveName: string) {
      self.archiveName = archiveName;
    },

    startDownload() {
      self.archiveNameSetupModalIsVisible = false;
      self.archiveName = self.defaultArchiveName;
    },

    hideArchiveNameSetupModal() {
      self.archiveNameSetupModalIsVisible = false;
    },
  }));

export type DownloadInspectionFilesState = Instance<typeof DownloadInspectionFilesModel>;
